var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgYeswareMegamenuIconSupport = function SvgYeswareMegamenuIconSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 8,
    fill: "#ECF6FB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3153_81265)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3153_81265)",
    fill: "#29ABE2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.945 14.453h-5.668a.471.471 0 0 1-.462-.458V8.352c0-.183.246-.275.37-.153l5.914 5.888c.154.122.03.366-.154.366Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.1 15.368h-6.747a.472.472 0 0 1-.462-.458V8.23a.406.406 0 0 0-.4-.397h-6.9c-.716 0-.925.397-.925.915v16.503c0 .519.4.915.925.915h13.985a.903.903 0 0 0 .924-.915v-9.487a.406.406 0 0 0-.4-.396Zm-5.114 4.759h-1.94v1.921a.472.472 0 0 1-.463.458.471.471 0 0 1-.462-.458v-1.921h-1.94a.471.471 0 0 1-.463-.458c0-.244.216-.457.462-.457h1.941V17.29c0-.244.216-.458.462-.458.247 0 .462.214.462.458v1.922h1.94c.247 0 .463.213.463.457a.471.471 0 0 1-.462.458Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3153_81265"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.667 7.833)",
    d: "M0 0h15.833v18.333H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3153_81265"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(9.667 7.833)",
    d: "M0 0h15.833v18.333H0z"
  })))));
};
export default SvgYeswareMegamenuIconSupport;